import { AxiosError } from "axios";

const handleAxiosError = (error: unknown): never => {
  const err = error as AxiosError;
  console.error("Axios Request Failed:", err.message);

  if (err.response) {
    console.error("Status:", err.response.status);
    console.error("Data:", err.response.data);
  }
  throw new Error(err.message);
};
export { handleAxiosError };
